export default "__VITE_ASSET__Bz7FEjPz__"